export function operacaoCotaDistribUnidadeInRequest(params = {}) {
  return {
    type: '@operacaocotadistribunidade/VISUACOTADISTRIBUNIDADE_IN_REQUEST',
    payload: { params },
  };
}

export function findOperacaoCotaDistribUnidade(orga_codigo, unid_cogigo) {
  return {
    type: '@operacaocotadistribunidade/FIND_VISUACOTADISTRIBUNIDADE',
    payload: { orga_codigo, unid_cogigo },
  };
}

export function failedRequest() {
  return {
    type: '@operacaocotadistribunidade/FAILED_REQUEST',
  };
}

export function deleteOperacaoCotaDistribUnidade(orga_codigo, unid_cogigo, params) {
  return {
    type: '@operacaocotadistribunidade/DELETE_VISUACOTADISTRIBUNIDADE',
    payload: { orga_codigo, unid_cogigo, params },
  };
}

export function updateOperacaoCotaDistribUnidade(operacaocotadistribunidade, params) {
  return {
    type: '@operacaocotadistribunidade/UPDATE_VISUACOTADISTRIBUNIDADE',
    payload: { operacaocotadistribunidade, params },
  };
}

export function storeOperacaoCotaDistribUnidade(operacaocotadistribunidade, params) {
  return {
    type: '@operacaocotadistribunidade/STORE_VISUACOTADISTRIBUNIDADE',
    payload: { operacaocotadistribunidade, params },
  };
}

export function successInRequest(
  operacaocotadistribunidade,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@operacaocotadistribunidade/SUCCESS_IN_REQUEST',
    payload: { operacaocotadistribunidade, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(operacaocotadistribunidade) {
  return {
    type: '@operacaocotadistribunidade/SUCCESS_REQUEST',
    payload: { operacaocotadistribunidade },
  };
}

export function successRemove(params) {
  return {
    type: '@operacaocotadistribunidade/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@operacaocotadistribunidade/RECORD_FILTERING',
    payload: { params },
  };
}
